export default "__VITE_ASSET__96d32146__"